<template>
    <div>
        <notifications position="top right" group="foo" />
        <router-view></router-view>
    </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
@import 'assets/scss/style';
</style>
